import { TickMath } from "@uniswap/v3-sdk"

import { toBigInt, toJSBI } from "./jsbi-bigint"

export const MIN_TICK = TickMath.MIN_TICK
export const MAX_TICK = TickMath.MAX_TICK
export const MIN_SQRT_RATIO: bigint = toBigInt(TickMath.MIN_SQRT_RATIO)
export const MAX_SQRT_RATIO: bigint = toBigInt(TickMath.MAX_SQRT_RATIO)

export function getSqrtRatioAtTick(tick: number): bigint {
  return toBigInt(TickMath.getSqrtRatioAtTick(tick))
}

export function getTickAtSqrtRatio(sqrtRatioX96: bigint): number {
  return TickMath.getTickAtSqrtRatio(toJSBI(sqrtRatioX96))
}
